import styled, { css } from 'styled-components';

export const Container = styled.article`
    ${({ theme }) => css`
        position: relative;
        overflow: hidden;
        border: 0.0625rem solid var(--card-border-colour, ${theme.colors.secondary.tints[0].hex});
        border-radius: 0.5rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: var(--card-bg-colour, ${theme.colors.background.hex});
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        width: 100%;
        height: 7rem;
        margin-bottom: 0.5rem;
        overflow: hidden;
        flex: 0 0 auto;

        @media ${theme.breakpoints.medium.media} {
            height: 8rem;
        }

        @media ${theme.breakpoints.large.media} {
            height: 11.25rem;
            margin-bottom: 0rem;
        }
    `}
`;

export const Content = styled.div`
    ${({ theme }) => css`
        padding: 0 1rem 1.25rem;
        display: flex;
        flex-direction: column;
        flex-grow: 1;

        *:last-child {
            margin-bottom: 0;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 0 1rem 1.5rem;
        }
    `}
`;

export const Heading = styled.h3`
    ${({ theme }) => css`
        font-size: 1.75rem;
        line-height: 2rem;
        font-weight: 700;
        color: var(--card-h-colour, ${theme.colors.tertiary.hex});
        margin: 1.5rem 0 1rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 2rem;
            line-height: 1.4;
        }

        & + p {
            margin-top: 0;
        }
    `}
`;

export const LinkWrapper = styled.div`
    margin-top: auto;
`;
